import { render, staticRenderFns } from "./EditPasswordDialog.vue?vue&type=template&id=6e9cfc4e&scoped=true&"
import script from "./EditPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./EditPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9cfc4e",
  null
  
)

export default component.exports